import API from "@http"
import Types from "@redux/types/auth/forgot-password.type";
const isLoading = (dispatch) => {
    dispatch({
        type: Types.FORGOT_PASSWORD_REQUEST
    });
};

const isError = (dispatch, error) => {
    console.log(error.response?.data?.message)
    dispatch({
        type: Types.FORGOT_PASSWORD_ERROR,
        payload: {
            forgotPasswordState: "error",
            statusMessage: error.response?.data?.message
        }
    });
};

export const RequestForgotPasswordLink = (email) => async (dispatch, getState) => {
    isLoading(dispatch);
    try {
        const response = await API.post("/auth/request_reset_password", {
            email
        });
        
        dispatch({
            type: Types.FORGOT_PASSWORD_CHECK,
            payload: { data: response.data, forgotPasswordState: "request_success" }
        });
    } catch (error) {
        console.log(error)
        isError(dispatch, error);
    }
};

export const ChangePassword = (passwordCode, password) => async (dispatch, getState) => {
    isLoading(dispatch);
    try {
        const response = await API.post("/auth/change_password", {
            passwordCode,
            password
        });
        
        dispatch({
            type: Types.FORGOT_PASSWORD_CHECK,
            payload: { data: response.data, forgotPasswordState: "success" }
        });
    } catch (error) {
        console.log(error)
        isError(dispatch, error);
    }
};

export const RequestForgotPasswordLinkByCode = (passwordCode) => async (dispatch, getState) => {
    isLoading(dispatch);
    try {
        const response = await API.post("/auth/request_reset_password_by_code", {
            passwordCode
        });
        
        dispatch({
            type: Types.FORGOT_PASSWORD_CHECK,
            payload: { data: response.data, forgotPasswordState: "request_success" }
        });
    } catch (error) {
        console.log(error)
        isError(dispatch, error);
    }
};


export const ResetState = () => async (dispatch, getState) => {
    isLoading(dispatch);
    try {
        dispatch({
            type: Types.FORGOT_PASSWORD_CHECK,
            payload: { forgotPasswordState: "" }
        });
    } catch (error) {
        console.log(error)
        isError(dispatch, error);
    }
};


export const CheckPasswordCode = (passwordCode) => async (dispatch, getState) => {
    isLoading(dispatch);
    try {
        const response = await API.post("/auth/validate_reset_password", {
            passwordCode
        });
        
        dispatch({
            type: Types.FORGOT_PASSWORD_CHECK,
            payload: { data: response.data, forgotPasswordState: "success_validate" }
        });
    } catch (error) {
        console.log(error)
        isError(dispatch, error);
    }
};